import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import Loader from "react-spinners/PropagateLoader";
import { login } from "../../services/auth";
import { setAccessToken, setRefreshToken } from "../../utils/auth";

export default function SignIn() {
    const [errorMessage, setErrorMessage] = useState("");
    const [errorState, setErrorState] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent page refresh
        setLoading(true);
        setErrorMessage("");
        setErrorState("");

        if (!(username && password)) {
            setLoading(false);
            setErrorMessage("نام کاربری یا رمزعبور وارد نشده است.");
            return;
        }

        try {
            const loginRequest = {
                username: username,
                password: password,
            };

            const response = await login(loginRequest);

            // Store tokens in cookies or local storage
            setAccessToken(response.data.data.access);
            setRefreshToken(response.data.data.refresh);

            // Navigate to admin page after successful login
            navigate("/admin");
        } catch (error) {
            console.log(error)
            setLoading(false);
            if (error.response && error.response.status === 400) {
                setErrorState("error");
                setErrorMessage(error.response.data?.detail || "اطلاعات نامعتبر است");
            } else {
                console.error("Error during login:", error);
                setErrorMessage("خطا در ارتباط با سرور");
            }
        }
    };

    return (
        <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center">
            <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]" style={{ direction: "rtl" }}>
                <div className="text-center text-teal-300 mb-12 font-extrabold text-3xl border shadow-2xl shadow-teal-600 p-6 border-teal-400 rounded-2xl">
                    ورود به صفحه مدیریت
                </div>
                <form onSubmit={handleSubmit}>
                    {/* Username Field */}
                    <InputField
                        variant="auth"
                        extra="mb-3"
                        labelExtra="!text-white"
                        label="نام کاربری:"
                        id="username"
                        disabled={loading}
                        state={errorState}
                        onChange={(e) => setUsername(e.target.value)}
                        type="text"
                    />

                    {/* Password Field */}
                    <InputField
                        variant="auth"
                        extra="mb-3"
                        labelExtra="!text-white"
                        label="رمزعبور:"
                        id="password"
                        disabled={loading}
                        state={errorState}
                        onChange={(e) => setPassword(e.target.value)}
                        type="password"
                    />

                    {/* Error Message */}
                    {errorMessage && (
                        <p className="text-sm font-bold text-red-500 my-4">
                            {errorMessage}
                        </p>
                    )}

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                    >
                        {loading ? (
                            <div className="h-5 flex items-center justify-center mb-2">
                                <Loader loading={true} color="#fff" />
                            </div>
                        ) : (
                            "ورود"
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}
